module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_summersale-af7e5cc8735c11af3d6978b639596f21.png";